import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DynamicForm from "Component/DynamicForm";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { ErrorMessages } from "Constants";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

class Design extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 0,
      value: ["1000", "4500"],
    };

    this.handleSlider = this.handleSlider.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.valuetext = this.valuetext.bind(this);
  }

  componentDidMount() {
    if (this.props.editableKey) {
      this.props.onRef({
        onNext: this.onSubmit,
        nextButtonLabel: "Save",
      });
    } else {
      this.props.onRef({
        onCancel: this.props.onCancel,
        onPrev: this.props.onPrevClick,
      });
    }
  }

  onSubmit() {
    const { postData } = this.props;
    if (
      postData.fbpcomponent.find(
        (x) =>
          (x.lowerlimit != 0 && !x.lowerlimit) ||
          (x.upperlimit != 0 && !x.upperlimit),
      )
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, {
        variant: "error",
      });
    } else if (postData.fbpcomponent.find((x) => x.lowerlimit > x.upperlimit)) {
      this.props.enqueueSnackbar(
        "Lower limit should be less than or equal to upper limit",
        {
          variant: "error",
        },
      );
    } else {
      this.props.onSave();
    }
  }

  handleSlider(e, newValue, index) {
    const { postData } = this.props;
    if (newValue) {
      postData.fbpcomponent[index].lowerlimit = newValue[0];
      postData.fbpcomponent[index].upperlimit = newValue[1];
    }
    this.setState(
      {
        value: newValue,
      },
      () => {
        this.props.updatePostData(postData);
      },
    );
  }

  valuetext(value) {
    return `${value}`;
  }

  handleChange(value, key, index) {
    const { postData } = this.props;
    if (!value) {
      if (key == "lowerlimit") {
        postData.fbpcomponent[index][key] = 0;
      } else {
        postData.fbpcomponent[index][key] = 1;
      }
    } else {
      postData.fbpcomponent[index][key] = value;
    }

    this.setState(
      {
        [key]: value,
      },
      () => {
        this.props.updatePostData(postData);
      },
    );
  }

  render() {
    const { fbpcomponent } = this.props.postData;
    return (
      <IntlProvider locale="en" messages={""}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content" style={{ width: "50%" }}>
            <div
              style={{ fontSize: 18, fontWeight: "bold", margin: "20px 0px" }}
            >
              Configure minimum and maximum monthly claim amount
            </div>
            {fbpcomponent &&
              fbpcomponent.map((comp, index) => (
                <div className="margin-top-30">
                  <p className="small-dark-secondary t-bold">
                    {comp.displayname || comp.componentname}
                  </p>
                  <Grid container>
                    <Grid
                      item
                      md={12}
                      xs={12}
                      sm={12}
                      lg={12}
                      style={{ marginLeft: 20 }}
                    >
                      {/* <Typography id="discrete-slider" gutterBottom /> */}

                      <Slider
                        className="margin-top-10"
                        value={[comp.lowerlimit, comp.upperlimit]}
                        onChange={(e, value) =>
                          this.handleSlider(e, value, index)
                        }
                        valueLabelDisplay="auto"
                        min={0}
                        max={1000000}
                        step={10}
                        disabled={this.props.editableKey ? false : true}
                        aria-labelledby="discrete-slider"
                        getAriaValueText={(value) => this.valuetext(value)}
                      />
                    </Grid>
                    <Grid container>
                      <Grid item md={3} xs={12} sm={12} lg={3}>
                        <DynamicForm
                          fields={integerinputconverter({
                            value: comp.lowerlimit,
                            placeholder: "Enter limit",
                            label: "Min",
                            min: 0,
                            disabled: this.props.editableKey ? false : true,
                          })}
                          onChange={(value) => {
                            this.handleChange(value, "lowerlimit", index);
                          }}
                        />
                      </Grid>
                      <Grid item md={6} xs={12} sm={12} lg={6}></Grid>
                      <Grid item md={3} xs={12} sm={12} lg={3} className="">
                        <DynamicForm
                          fields={integerinputconverter({
                            value: comp.upperlimit,
                            placeholder: "Enter limit",
                            label: "Max",
                            min: 1,
                            disabled: this.props.editableKey ? false : true,
                          })}
                          onChange={(value) => {
                            this.handleChange(value, "upperlimit", index);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              ))}
          </div>
        </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Design)));
